import { login, logout } from "../../redux/slices/authSlice";
import instance, { instanceFile } from "../../ApiConfig";
import { URLS } from "../../ApiConfig/Urls";
import { distroySettting } from "../../redux/slices/settingslice";

const fetchRides = async () => {
  try {
    // console.log("Hello", URLS.GetAdmin + URLS.GetRides);
    const response = await instance.get(URLS.GetAdmin + URLS.GetRides);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchRidesByID = async (driver_id) => {
  try {
    // console.log("Hello", URLS.GetAdmin + URLS.GetRides);
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetRidesByID + driver_id
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchRidesByStatus = async (status) => {
  try {
    console.log("Hello", status);
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetRidesByStatus + status
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

export default {
  fetchRides,
  fetchRidesByID,
  fetchRidesByStatus,
};
